import {useState, useContext, useEffect} from "react"
import {useNavigate, useLocation} from "react-router-dom"
import {Form} from "react-final-form"
import {WrapperContainer, AlertDialog, Button} from "ui"
import Question from "../../utils/Question"
import {
  MILITARY_ALERT,
  MILITARY_QUESTIONS,
} from "../../../constants/accounts/military"
import {
  RoutePaths,
  FormButton,
  Options,
  QuestionsInterface,
} from "../../../constants"
import {nacMachineContext} from "../../../context"
import {NACEvents, NACStates} from "../../../machine/nac-machine.types"

const Military = () => {
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()
  const {state, send} = useContext(nacMachineContext) || {}

  const onSubmit = (values: {staff: string; location: string}) => {
    const {location} = values
    if (parseInt(location) === Options.NO) {
      setOpen(true)
    } else {
      send(NACEvents.NEXT, {data: {...values}})
      navigate(RoutePaths.SELECT_TRANSACTION_TYPE)
    }
  }

  const renderAlertBox = () => {
    return (
      <AlertDialog
        open={open}
        setOpen={setOpen}
        title={MILITARY_ALERT.title}
        description={MILITARY_ALERT.description}
      />
    )
  }

  type valuesType = {staff: string; location: string}
  const renderSubQuestion = (
    question: QuestionsInterface<Options>,
    values: valuesType,
    index: number,
  ) => {
    if (
      question?.SUB_QUESTIONS &&
      question?.SUB_QUESTIONS[index].EXPECTED_PARENT_VALUE.includes(
        parseInt(values.staff),
      )
    ) {
      return (
        <>
          <Question
            questions={question?.SUB_QUESTIONS[index].QUESTIONS}
            renderSubQuestion={renderSubQuestion}
            values={values}
            subQuestion={true}
          />
        </>
      )
    }
  }

  useEffect(() => {
    if (state?.value !== NACStates.validateMilitaryAccount) {
      send(NACEvents.INIT, {data: {route: location.pathname}})
    }
  }, [])

  return (
    <div className="flex justify-center">
      <div className="w-full sm:w-[520px]">
        <WrapperContainer>
          <Form
            initialValues={{
              staff: state.context.validateMilitary?.staff,
              location: state.context.validateMilitary?.location,
              firstName: state.context.validateMilitary?.firstName,
              lastName: state.context.validateMilitary?.lastName,
              vetLicense: state.context.validateMilitary?.vetLicense,
            }}
            validateOnBlur={true}
            onSubmit={onSubmit}
            render={({handleSubmit, invalid, values}) => (
              <form onSubmit={handleSubmit}>
                <Question
                  questions={MILITARY_QUESTIONS}
                  renderSubQuestion={renderSubQuestion}
                  values={values}
                />
                <div className="flex justify-end gap-8">
                  <Button
                    variant="text"
                    onClick={() => {
                      send(NACEvents.BACK)
                      navigate(RoutePaths.ACCOUNT_TYPE)
                    }}
                  >
                    {FormButton.BACK}
                  </Button>
                  <Button
                    disabled={invalid}
                    variant="primary"
                    mode="filled"
                    type="submit"
                  >
                    {FormButton.CONTINUE}
                  </Button>
                </div>
              </form>
            )}
          />
          {renderAlertBox()}
        </WrapperContainer>
      </div>
    </div>
  )
}

export default Military
